import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Ajax } from '../../../classes/ajax';

function StockController({active, onFailure}) {
    const tickets = useSelector(
        state => state.cart.confirmed_tickets != null
            ? state.cart.confirmed_tickets.map(t => t.id)
            : [],
    );

    const hotels = useSelector(
        state => state.cart.confirmed_hotel != null
            ? state
                .cart
                .confirmed_hotel
                .ranges[state.cart.selected_hotel_nights][state.cart.selected_hotel_range]
                .variations.map(h => h.id)
            : [],
    );

    const roomType = useSelector(state => state.hotels.selected_hotel_room_type);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!active || (tickets.length === 0 && hotels.length === 0)) {
                return;
            }

            const request = {
                tickets: {
                    quantity: tickets.length,
                    ids: tickets.filter((t, i, a) => a.indexOf(t) === i),
                },
            };

            if (hotels.length > 0) {
                request.hotels = {
                    ids: hotels,
                    room_type: roomType,
                };
            }

            if (window.NOJESRESOR_ORDER != null) {
                request.order_id = NOJESRESOR_ORDER;
            }

            const onSuccessResponse = response => {
                if (!response || !response.data) {
                    return;
                }

                if (!response.data.in_stock) {
                    onFailure(
                        response.data.type === 'tickets',
                        response.data.type === 'hotels',
                    );
                }
            };

            new Ajax('POST', 'stock', request)
                .then(onSuccessResponse, () => null)
                .catch(() => null);
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, [tickets, hotels, roomType]);

    return null;
}

export default StockController;
